/* eslint-disable no-param-reassign */
export default class AdsModel {
  constructor(blockAds) {
    this.indexSelected = 0;
    this.adsData = blockAds.ads || [];
    if (Array.isArray(this.adsData)) {
      this.adsData.forEach((element, index) => {
        // eslint-disable-next-line no-param-reassign
        element.index = index;
      });
    } else {
      this.adsData = [];
    }
    this.numAdsByBlock = blockAds.numAdsByBlock;
    this.position = blockAds.position;
    this.enableImaSDK = true;
    this.loopEnabled = false;
    this.extInfo = blockAds.extInfo;
  }

  getNumAdsByBlock() {
    return parseInt(this.numAdsByBlock, 10);
  }

  getPosition() {
    return this.position;
  }

  getAds() {
    return this.adsData;
  }

  isImaAd() {
    return this.enableImaSDK;
  }

  isPrebid() {
    return this.getItemSelected().bid;
  }

  getExtInfo() {
    return this.extInfo;
  }

  getDeliveryAds() {
    return this.adsData.filter(
      (item) =>
        typeof item.adController !== 'undefined' &&
        typeof item.delivered === 'undefined' &&
        typeof item.ended === 'undefined' &&
        typeof item.error === 'undefined',
    );
  }

  getAdsToRequest() {
    return this.adsData.filter(
      (item) => typeof item.adController === 'undefined' && typeof item.error === 'undefined',
    );
  }

  getErrorAds() {
    return this.adsData.filter((item) => typeof item.error !== 'undefined');
  }

  getTotalAds() {
    return this.getAds().length;
  }

  getItemSelected() {
    return this.adsData[this.indexSelected];
  }

  resetAds() {
    this.adsData.forEach((ad) => {
      if (ad.delivered && ad.ended) {
        ad.adController = undefined;
        ad.delivered = undefined;
        ad.ended = undefined;
      }
    });
  }

  addNewAds(blockAd) {
    this.adsData = this.adsData.concat(blockAd.ads);
  }

  // getNextItem() {
  //   if (this.isNextItem()) {
  //     this.indexSelected += 1;
  //     return this.getItemSelected();
  //   }
  //   if (this.loopEnabled) {
  //     this.indexSelected = 0;
  //     return this.getItemSelected();
  //   }
  //   return false;
  // }

  // getPreviousItem() {
  //   logDebugging('this.indexSelected before', this.indexSelected);
  //   if (this.isPreviousItem()) {
  //     this.indexSelected -= 1;
  //     logDebugging('this.indexSelected after', this.indexSelected);
  //     return this.getItemSelected();
  //   }
  //   if (this.loopEnabled) {
  //     this.indexSelected = this.adsData.length - 1;
  //     return this.getItemSelected();
  //   }

  //   return false;
  // }

  // isNextItem() {
  //   return this.indexSelected < this.adsData.length - 1;
  // }

  // isPreviousItem() {
  //   return this.indexSelected !== 0;
  // }
}
